'use client'

import 'lenis/dist/lenis.css'

import { ReactLenis } from 'lenis/react'

// Landing-only smooth scroll. Light damping (lerp 0.15 vs the library's 0.1
// default) keeps the page close to native — a finish, not a ride. Touch
// devices stay fully native (syncTouch defaults false) and Lenis itself
// disables smoothing under prefers-reduced-motion, so no manual guard here.
// anchors: true carries the top-rail's in-page #section jumps through the
// same damping instead of teleporting.
export function SmoothScroll() {
    return <ReactLenis root options={{ lerp: 0.15, anchors: true }} />
}
